import React, { Component } from 'react';
import { Label, DatePickerCalendar, Switch } from 'app/components/Basics/';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import { dynamicDemoParamTypes } from '../../../../../constants/dynamic-demo-param-types';
import { Input as EcoInput } from '@ecosystem/ui-lib/core/components/Input';
import './GlobalFieldLineComponent.scss';
import { DynamicDemoFormContext } from '../../DynamicDemoContext';
import MultiSelect from 'app/components/MultiSelect'
import MultiFreeText from 'app/components/MultiFreeText'
import { Card } from '@ecosystem/ui-lib';

class GlobalFieldLine extends Component {
	static contextType = DynamicDemoFormContext;

	constructor(props) {
		super(props);
		this.state = {
			comparisonTypes: [
				{ value: "0", label: "At Least" },
				{ value: "1", label: "At Most" },
				{ value: "2", label: "Exactly" }
			]
		};
	}

	setStartDate(date) {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		selectedDynamicDemo.startDate = date;
		this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
	}

	setEndDate(date) {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		selectedDynamicDemo.endDate = date;
		this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
	}

	enabledSwitchHandler() {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		selectedDynamicDemo.enabled = selectedDynamicDemo.enabled === 1 ? 0 : 1;
		this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
	}

	userCannotChangeData() {
		return !this.props.canChangeData;
	}
	
	questionCodeHandler = event => {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		selectedDynamicDemo.dynamicDemoQuestion.demoQuestionCode = event.target.value;
		this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
	}

	questionTextHandler = event => {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		selectedDynamicDemo.dynamicDemoQuestion.demoQuestionText = event.target.value;
		this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
	}

	changeComparisonTypeHandler(newType) {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		selectedDynamicDemo.comparisonType = parseInt(newType.value);
		this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
	}

	getSelectedComparisonTypeOption() {
		return this.state.comparisonTypes.find(t => parseInt(t.value) === this.context.selectedDynamicDemo.comparisonType);
	}

	numberOfDaysdHandler = event => {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		selectedDynamicDemo.numberOfDays = event.target.value ? parseInt(event.target.value) : null;
		this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
	}

	numberOfTimesdHandler = event => {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		selectedDynamicDemo.numberOfTimes = event.target.value ? parseInt(event.target.value) : null;
		this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
	}
	
	getParamsByType(paramType) {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		if (!selectedDynamicDemo?.dynamicDemographicParams) return [];
		
		return selectedDynamicDemo.dynamicDemographicParams
			.filter(d => d.dynamicDemographicParamType === paramType)
			.map(d => d.paramValue);
	}	

	setParamsByType(paramType, paramValues) {
		const selectedDynamicDemo = this.context.selectedDynamicDemo;
		const existingParams = selectedDynamicDemo.dynamicDemographicParams || [];
		
		const otherTypesParams = existingParams.filter(param => param.dynamicDemographicParamType !== paramType);
		const newParamsForType = paramValues.map(value => ({dynamicDemographicParamType: paramType, paramValue: value}));	
		
		selectedDynamicDemo.dynamicDemographicParams = [...otherTypesParams, ...newParamsForType];
	
		return selectedDynamicDemo;
	  }

	handleQuestionChange = (selectedOptions) => {
		const selectedQuestionCodes = selectedOptions.map(o => o.value);
		const updatedDemo = this.setParamsByType(dynamicDemoParamTypes.QuestionCode, selectedQuestionCodes);
		this.context.updateSelectedDynamicDemo(updatedDemo);
	};

	handleQuestionRemove = (removedOption) => {
		const questionCodes = this.getParamsByType(dynamicDemoParamTypes.QuestionCode).filter(v => v !== removedOption.value);
		const updatedDemo = this.setParamsByType(dynamicDemoParamTypes.QuestionCode, questionCodes);
		this.context.updateSelectedDynamicDemo(updatedDemo);
	};

	addNewProgramTitle = (newTitle) => {		
		const currentTitles = this.getParamsByType(dynamicDemoParamTypes.ProgramTitle);		
		const updatedDemo = this.setParamsByType(dynamicDemoParamTypes.ProgramTitle, [newTitle, ...currentTitles]);		
		this.context.updateSelectedDynamicDemo(updatedDemo);
	  };
	
	  removeProgramTitle = (index) => {		
		const currentTitles = this.getParamsByType(dynamicDemoParamTypes.ProgramTitle);
		const newTitles = currentTitles.filter((title, i) => i !== index);
		const updatedDemo = this.setParamsByType(dynamicDemoParamTypes.ProgramTitle, newTitles);		
		this.context.updateSelectedDynamicDemo(updatedDemo);
	  };

	handleChannelChange = (selectedOptions) => {
		const values = selectedOptions.map(o => o.value);
		const updatedDemo = this.setParamsByType(dynamicDemoParamTypes.Channel, values);
		this.context.updateSelectedDynamicDemo(updatedDemo);
	};

	handleChannelRemove = (removedOption) => {
		const currentChannels = this.getParamsByType(dynamicDemoParamTypes.Channel).filter(v => v !== removedOption.value);
		const updatedDemo = this.setParamsByType(dynamicDemoParamTypes.Channel, currentChannels);
		this.context.updateSelectedDynamicDemo(updatedDemo);
	};

	getMultiSelectOptions(metadata, values) {
		return values
			.map(value => metadata.find(item => item.value === value))
			.filter(item => item !== undefined);
	}

	render() {
		const { selectedDynamicDemo } = this.context;
		const disabled = this.userCannotChangeData();
		return (
			<div>
				<div className="GlobalFieldLineComponent form-row">
					<div className="form-row-left">
						<div className="field-demo-code">
							<Label>Demo Question Code</Label>
							<EcoInput
								disabled={disabled}								
								value={selectedDynamicDemo.dynamicDemoQuestion.demoQuestionCode}
								onChange={this.questionCodeHandler}
								id="demo-question-code"
							/>
						</div>						
						<div className="field-demo-text">
							<Label>Demo Question Text</Label>
							<EcoInput
								disabled={disabled}								
								value={selectedDynamicDemo.dynamicDemoQuestion.demoQuestionText}
								onChange={this.questionTextHandler}
								id="demo-question-text"
							/>
						</div>
					</div>
				</div>

				<div className="GlobalFieldLineComponent form-row">
					<div className="form-row-left">
						<div className="field-survey-from">
							<Label>Active From</Label>
							<DatePickerCalendar
								disabled={disabled}
								value={selectedDynamicDemo.startDate}
								onChange={this.setStartDate.bind(this)}
							/>
						</div>
						<div className="field-survey-to">
							<Label>Active To</Label>
							<DatePickerCalendar
								disabled={disabled}
								value={selectedDynamicDemo.endDate}
								minDate={selectedDynamicDemo.startDate}
								onChange={this.setEndDate.bind(this)}
							/>
						</div>						
					</div>
				</div>

				<div className="GlobalFieldLineComponent form-row">
					{/* <Card className='condition-block'> */}
						<div className="form-row-left">		
							<div><Label>In the last</Label></div>				
							<div className="field-days">							
								
									<EcoInput
										disabled={disabled}
										type="number"
										value={selectedDynamicDemo.numberOfDays || ''}
										onChange={this.numberOfDaysdHandler}
										id="number-of-days"
									/>
									{/* <span className="inline-label-right">Days</span> */}
								
							</div>
							<div className='label-days'><Label>day(s), it should have happened</Label></div>						
							<div className="field-comparison">							
								<Select
									isDisabled={disabled}
									name="qctype"
									isSearchable={false}
									onChange={val => this.changeComparisonTypeHandler(val)}
									options={this.state.comparisonTypes}
									value={this.getSelectedComparisonTypeOption()}
								/>
							</div>
							<div className="field-times">
									<EcoInput
										disabled={disabled}
										type="number"
										value={selectedDynamicDemo.numberOfTimes || ''}
										onChange={this.numberOfTimesdHandler}
										id="number-of-times"
									/>
									{/* <span className="inline-label-right">Times</span> */}
								
							</div>
							<div className='label-times'><Label>times</Label></div>
						</div>
					{/* </Card> */}
				</div>

				<div className="GlobalFieldLineComponent form-row">
					<div className="form-row-left dyndemo-filters">
						<div className="field-questions">
							<Label>Question Codes</Label>
							<MultiSelect
								isDisabled={disabled}
								selectedOptions={this.getMultiSelectOptions(
									this.props.metadata.questions,
									this.getParamsByType(dynamicDemoParamTypes.QuestionCode)
								)}
								onChange={this.handleQuestionChange}
								onRemove={this.handleQuestionRemove}
								options={this.props.metadata.questions}
							/>
						</div>

						<div className="field-program-title">
							<Label>Program Titles</Label>
							<MultiFreeText
								disabled={disabled}
								values={this.getParamsByType(dynamicDemoParamTypes.ProgramTitle)}
								addNewTextHandler={this.addNewProgramTitle}
          						removeTextHandler={this.removeProgramTitle}
								placeholder="Add program title..."
							/>
						</div>

						<div className="field-channels">
							<Label>Channels</Label>
							<MultiSelect
								isDisabled={disabled}
								selectedOptions={this.getMultiSelectOptions(
									this.props.metadata.channels,
									this.getParamsByType(dynamicDemoParamTypes.Channel)
								)}
								onChange={this.handleChannelChange}
								onRemove={this.handleChannelRemove}
								options={this.props.metadata.channels}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

GlobalFieldLine.contextType = DynamicDemoFormContext;

export default GlobalFieldLine;